<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <ImageCover
          :aspect-ratio="aspectRatio"
          :value="article"
          class="text-right"
          default-key="article_default_image"
          max-height="800"
          max-width="1600"
        >
          <ShareLinkButton class="ma-1" variant="flat" />
        </ImageCover>
      </v-col>
    </v-row>

    <v-row cols="12">
      <v-col class="text-overline">
        <ResourceDate :value="article" />
      </v-col>
    </v-row>

    <v-row v-if="article.body">
      <v-col cols="12">
        <!-- eslint-disable vue/no-v-html -->
        <div class="text-body-1" v-html="article.body"></div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <ResourceTags :value="article" />
      </v-col>
    </v-row>

    <v-row v-if="article.downloads && article.downloads.length">
      <v-col cols="12">
        <v-card rounded="0" variant="flat">
          <v-list lines="one">
            <v-list-subheader class="text-h5 mb-2"
              >Related Downloads</v-list-subheader
            >
            <v-divider />

            <template v-for="download in article.downloads" :key="download.id">
              <v-list-item :href="downloadHref(download)">
                <v-list-item-title>{{ download.title }}</v-list-item-title>
              </v-list-item>
              <v-divider />
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { downloadHref } from '#root/lib/utils'

defineProps({
  article: {
    required: true,
    type: Object
  },
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 16 / 9
</script>
